import React from 'react';
import { styled, Chip, SxProps, Theme } from '@mui/material';

export const CHIP_HEIGHT_LG = 40;

const StyledChip = styled(Chip)(() => ({
  fontWeight: 600,
  borderRadius: 999,
  mt: { xs: 1, md: 0 },
  display: 'inline-flex',
  justifyContent: 'left',
  fontSize: '14px',
}));

const chipColorMap: Record<string, { backgroundColor: string; color: string }> = {
  green: { backgroundColor: '#B0E1C0', color: '#066626' },
  yellow: { backgroundColor: '#FFE3AD', color: '#5C4300' },
  red: { backgroundColor: '#EEADAD', color: '#860000' },
  gray: { backgroundColor: '#DEDCDD', color: '#444243' },
  rose: { backgroundColor: '#A73A64', color: '#FFFFFF' },
  roseLight: { backgroundColor: '#F8E3EA', color: '#A73A64' },
  bluebell: { backgroundColor: '#266180', color: '#FFFFFF' },
  bluebellLight: { backgroundColor: '#D9E8F0', color: '#266180' },
};

export type MoChipColor = keyof typeof chipColorMap;

export type MoChipSize = 'sm' | 'md' | 'lg';
const chipSizeMap: Record<MoChipSize, { height: number }> = {
  sm: { height: 24 },
  md: { height: 32 },
  lg: { height: CHIP_HEIGHT_LG },
};

type MoChipProps = {
  label: string;
  color?: MoChipColor;
  size?: MoChipSize;
  sx?: SxProps<Theme>;
};

export const MoChip = ({ label, color = 'gray', size = 'md', sx }: MoChipProps) => {
  return <StyledChip label={label} sx={{ ...chipColorMap[color], ...chipSizeMap[size], ...sx }} />;
};
